/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs */

const en_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all Events in Event Group starting the currently selected event.`)
};

const fr_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner tous les evenements du groupe a partir de l'evenement selectionne.`)
};

const de_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie alle Ereignisse in der Ereignisgruppe aus, beginnend mit dem aktuell ausgewählten Ereignis.`)
};

const it_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutti gli eventi nel gruppo eventi avviando l'evento attualmente selezionato.`)
};

const ru_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите все события в группе событий, начиная с текущего выбранного события.`)
};

const es_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todos los eventos en el grupo de eventos comenzando por el evento seleccionado actualmente.`)
};

const zh_cn2_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择事件组中从当前选定事件开始的所有事件。`)
};

const ja_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在選択されているイベントから始まるイベント グループ内のすべてのイベントを選択します。`)
};

const hi_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान में चयनित इवेंट से शुरू होने वाले इवेंट ग्रुप में सभी इवेंट्स का चयन करें।`)
};

const pt_pt2_shortcut_keys_desc_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione todos os eventos no grupo de eventos, começando pelo evento atualmente selecionado.`)
};

/**
* | output |
* | --- |
* | "Select all Events in Event Group starting the currently selected event." |
*
* @param {Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_all_events_from_current = /** @type {((inputs?: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "de") return de_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "it") return it_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "es") return es_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_select_all_events_from_current(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_select_all_events_from_current(inputs)
	return en_shortcut_keys_desc_select_all_events_from_current(inputs)
});